<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="选择公司" prop="companyId" >
        <a-select
          v-model="form.companyId"
          placeholder="请选择"
          optionFilterProp="children"
          showSearch>
          <a-select-option v-for="(company,index) in companyList" :key="index" :value="company.id">{{ company.companyName }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="模板名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item>
        <a-button type="primary" @click="changeFields">
          <a-icon type="plus" />新增
        </a-button>
        <table cellspacing="0" class="table">
          <colgroup>
            <col style="width: 50px;">
            <col style="width: 100px;">
            <col style="width: 120px;">
          </colgroup>
          <thead>
            <tr>
              <th style="text-align: center;">序号</th>
              <th>字段名称</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in fields" :key="index">
              <td style="text-align: center;">
                {{ index + 1 }}
              </td>
              <td>{{ data }}</td>
              <td >
                <a :disabled="index < 8" @click="editField(data,index)">编辑</a>
                <a-divider type="vertical"/>
                <a :disabled="index < 8" @click="removeField(data,index)">删除</a>
              </td>
            </tr>
          </tbody>
        </table>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <FieldsForm ref="fieldsForm" @ok="addFields"/>
  </a-drawer>
</template>

<script>
import { getSalary, addSalary, updateSalary } from '@/api/user/salaryTemplate'
import { listCompany } from '@/api/user/company'
import FieldsForm from '@/views/user/salaryTemplate/modules/FieldsForm'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    FieldsForm
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      companyList: [],
      // fields: [ { name: '模板ID' }, { name: '工厂ID' }, { name: '工厂名称' }, { name: '姓名' }, { name: '身份证' }, { name: '发放年份' }, { name: '发放月份' }, { name: '实发工资' } ],
      defaultFidles: [ '模板ID', '工厂ID', '工厂名称', '姓名', '身份证', '发放年份', '发放月份', '实发工资'],
      fields: [],
      fieldIndex: null,
      // 表单参数
      form: {
        id: null,

        companyId: null,

        name: null,

        fields: null,

        status: 0,

        cateName: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      name: '',
      rules: {
        cateName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.queryCompanyList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    changeFields() {
      this.$refs['fieldsForm'].openModal(this.form.id, this.fields[this.fields.length], this.fields.length)
    },
    addFields(v) {
      console.log('name========', v)
      debugger
      var index = v.index
      var name = v.name
      if (index >= 0 && index < this.fields.length) {
        this.fields[index] = name
      } else {
        this.fields.push(name)
      }
      this.$forceUpdate()
    },
    editField(field, index) {
      debugger
      this.fieldIndex = index
      this.$refs['fieldsForm'].openModal1(this.form.id, field, index)
    },
    removeField(field, index) {
      this.fields.splice(index, 1)
    },
    queryCompanyList() {
      const param = {}
      listCompany(param).then(response => {
        this.companyList = response.data
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.fields = this.defaultFidles
      this.form = {
        id: null,
        companyId: null,
        name: null,
        fields: null,
        status: 0,
        cateName: null,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSalary({ 'id': id }).then(response => {
        this.form = response.data
        this.fields = response.data.fields.split(',')
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          this.form.fields = this.fields.join(',')
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSalary(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSalary(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  thead {
    tr {
      th {
        padding: 6px 8px;
        color: #000;
        font-weight: 500;
        text-align: left;
        background: #fafafa;
        border: 1px solid #e8e8e8;
        transition: background 0.3s ease
      }
    }
  }

  tbody {
    tr {
td {
  padding: 12px 8px;
  color: #000;
  text-align: left;
  background: #fff;
  border: 1px solid #e8e8e8;
  transition: background 0.3s ease;
  word-break: break-word;
  line-height: 18px;
}
}
}
}
</style>
